const getBackendUrl = () => {
  const { hostname, origin } = window.location;
  const port = '4000'; // Backend port for local/network development

  // Production: run API on the same origin under /api
  if (hostname === 'tinklas.mokslosala.eu') {
    return origin; // will be https://tinklas.mokslosala.eu
  }

  // Localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://localhost:${port}`;
  }

  // LAN / other hosts during development
  return `http://${hostname}:${port}`;
};

const BACKEND_URLS = [
  getBackendUrl(),
  'http://localhost:4000',
  'http://192.168.5.141:4000',
  'http://127.0.0.1:4000'
];

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  // Use the most reliable backend URL (production-aware)
  return `${getBackendUrl()}${imagePath}`;
};

export const getFallbackUrls = (imagePath) => {
  if (!imagePath) return [];
  
  const urls = [];
  
  // Add all backend URLs
  BACKEND_URLS.forEach(url => {
    urls.push(`${url}${imagePath}`);
  });
  
  // Add relative path as last resort
  urls.push(imagePath);
  
  return urls;
};

export const findWorkingImageUrl = async (urls) => {
  for (const url of urls) {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      if (response.ok) {
        return url;
      }
    } catch (error) {
      console.log(`Failed to load image from ${url}:`, error.message);
    }
  }
  return null;
}; 